module.exports = __webpack_public_path__ + "img/art16.fe6ed182.png";